/* global localize */
import React, { useContext, useState } from 'react';
import { useHistory, NavLink } from 'react-router-dom';
import { SurveyContext } from '../context/surveyContext';
import Modal from './Modal';

export default function Header() {
  const {
    survey,
    setSurvey,
    setResult,
    questionList,
    showActive,
    showActiveStart,
  } = useContext(SurveyContext);
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState(null);

  const history = useHistory();

  const handleClick = (text) => {
    setShowModal(!showModal);
    setModalText(text);
  };

  function reset() {
    setSurvey(null);
    setResult(null);
    history.push(localize.url);
  }

  return (
    <div>
      <div className={`top-header ${survey ? 'blackColor' : ''}`}>
        <h4 onClick={() => handleClick(localize.left_menu_text)}>
          {localize.left_menu}
        </h4>
        <h1 onClick={reset}>{localize.survey_logo_text}</h1>
        <h4 onClick={() => handleClick(localize.right_menu_text)}>
          {localize.right_menu}
        </h4>
        {showModal && (
          <Modal
            modalText={modalText}
            setModalText={setModalText}
            setShowModal={setShowModal}
          />
        )}
      </div>
      {survey && (
        <div className='nav-bar'>
          <div className='line1'></div>
          <div className='line2'></div>
          <NavLink
            to={`${localize.url}/start`}
            isActive={() => {
              if (showActiveStart) {
                return true;
              }
            }}
          >
            <span>1</span>
            {survey.survey_menu_label}
          </NavLink>
          <NavLink
            to={`${localize.url}/fragor`}
            isActive={() => {
              if (questionList.length !== 0) {
                return true;
              }
            }}
          >
            <span>2</span>
            Kompetensfrågor
          </NavLink>
          <NavLink
            to={`${localize.url}/resultat`}
            isActive={() => {
              if (showActive) {
                return true;
              }
            }}
          >
            <span>3</span>
            Resultat
          </NavLink>
        </div>
      )}
    </div>
  );
}
